var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-hash-blocks",attrs:{"target":_vm.target}},[_vm._t("default",null,{"currentHash":_vm.currentHash,"prevSlide":_vm.prevSlide,"nextSlide":_vm.nextSlide})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }